<div class="ui-procedure-buttons" [ngClass]="class">
    <div class="ui-procedure-button" (click)="onDebitAdd()">
        <div class="ui-button ui-shadow">
            <mat-icon>credit_card</mat-icon>
        </div>

        <p>Modificar mi débito automático</p>
    </div>

    <div class="ui-procedure-button" (click)="onComplaint()">
        <div class="ui-button ui-shadow">
            <mat-icon>record_voice_over</mat-icon>
        </div>
        
        <p>Denunciar conexión clandestina</p>
    </div>

    <div class="ui-procedure-button" (click)="onProductSubscribe()">
        <div class="ui-button ui-shadow">
            <mat-icon>add_circle_outline</mat-icon>
        </div>
        
        <p>Contratar plan</p>
    </div>

    <div class="ui-procedure-button" (click)="onProductChange()">
        <div class="ui-button ui-shadow">
            <mat-icon>compare_arrows</mat-icon>
        </div>

        <p>Modificar mi producto</p>
    </div>

    <div class="ui-procedure-button" (click)="onProductUnsubscribe()">
        <div class="ui-button ui-shadow">
            <mat-icon>cancel</mat-icon>
        </div>

        <p>Dar de baja un contrato</p>
    </div>

    <div class="ui-procedure-button" (click)="onNewProcedure()">
        <div class="ui-button ui-shadow">
            <mat-icon>add_task</mat-icon>
        </div>

        <p>Nueva gestión</p>
    </div>
</div>
